module.exports = {
    'TrackGoal': require('./track-goal'),
    'TrackLinkClick': require('./track-link-click')
};